// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var PaymentRefundDetailController = function ($scope, $routeParams, PaymentRefund, PaymentTransaction) {
    $scope.refund = PaymentRefund.get({ paymentRefundId: $routeParams.paymentRefundId }, function (data) {
        $scope.transaction = PaymentTransaction.get( { paymentTransactionId: data.PaymentTransactionId } );
    });

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Succeeded':
                return "label-success";
            case 'Failed':
                return "label-important";
            default:
                return '';
        }
    };
};
PaymentRefundDetailController.$inject = ['$scope', '$routeParams', 'PaymentRefund', 'PaymentTransaction'];
